import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import ContentModule from "../../modules/content_module";
import CTABtnModule from "../../modules/cta_btn_module";
import "./FeaturesPersons.scss";


const FeaturesPersons = ({Module}) => {

    return (
        <section className="feature-persons" id="feature-list">
            <Container>
                <Row>
                    <Col>
                        <div className="feature-persons-wrapper">                                
                            <ContentModule Content={Module?.title_content} /> 

                            <div className="tab-wrapper">
                                {Module?.feature_tab_module?.length > 0 && (
                                    <Tabs
                                        defaultActiveKey={Module?.feature_tab_module[0]?.tab_name}
                                        id="uncontrolled-tab-example"
                                        >
                                        {Module?.feature_tab_module.map((item, index) => {
                                            return(
                                                <Tab eventKey={item.tab_name} title={item.tab_name} >
                                                    <div className="tab_content">
                                                        <ContentModule Content={item?.content} /> 
                                                    </div>
                                                </Tab>
                                            )
                                        })}                                        
                                    </Tabs>
                                )
                                }                                
                            </div>

                            <div className="btn-wrapper">
                                {Module?.button_cta && Module?.button_cta.label && <CTABtnModule button_cta={Module?.button_cta} />}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

    );
};
export default FeaturesPersons;
